<script>
	import { store } from "$lib/utilities/store";

	import LoginForm from "$lib/sections/Admin/LoginForm.svelte";
	import Submissions from "$lib/sections/Submissions/Submissions.svelte";

	export let data;
	export let lang;

	$: uid = $store?.userProfile?.uid;
</script>

{#if !uid}
	<LoginForm {data} {lang} />
{:else}
	<Submissions />
{/if}
